import { axiosHelper } from 'Services/AxiosHelper';
import { OnCheckPhoneNumberModel } from 'Models';
import { onChangePhoneValidationReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnChangePhoneValidation';

const onChangePhoneValidation = async (params: onChangePhoneValidationReqBodyData): Promise<OnCheckPhoneNumberModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onChangePhoneValidation;
